<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-full height">
        <div class="container column is-12">
            <div class="section">
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Add New Category</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-create></data-create></div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Available Categories</p>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="content"><data-list v-bind:dataList="dataList"></data-list></div>
                    </div>
                </div>
                <br />

            </div>
        </div>
    </section>
</div>
</template>

<script>
import TopMenu from '../../TopMenu'
import axios from 'axios'
import DataList from '../BehaviourCategory/DataList';
import DataCreate from '../BehaviourCategory/DataCreate';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'DbBehaviourCategoryMain',
    components: {
        DataList,
        DataCreate,
        TopMenu,
        Loading,
    },
    data() {
        return {
            input: {
                name: ""
            },
            result: "",
            errors: [],
            dataList: [{
                name: '',
                done: false,
                status: "1"
            }],
            isLoading: false
        }
    },
    created() {
        this.getData()
        // console.log(this.$router.currentRoute.name)
        // this.currentRouteName = this.$router.currentRoute.name
    },
    beforeMount() {
        this.$emit("authenticated", true)
    },
    methods: {  
        getData() {

            let self = this;
            this.isLoading = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/behaviourCategory/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    this.dataList = response.data
                    self.isLoading = false
                })
                .catch(e => {
                    this.errors.push(e)
                    self.isLoading = false
                    console.log(e)
                })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Database/BehaviourCategory/Main.vue